export const store_config = {"data":{"config":{"paymentMethods":[],"cardAvailable":false,"internalHero":null}}}